/**
 * As setas ‹ › com o mês por extenso da aba Outros Bancos.
 *
 * Papel: reproduz `.month-nav` e `.month-label` (l. 138–142): os dois botões
 * com fundo `--superficie`, borda bege, raio de 6 px, `4px 11px` e 16 px na
 * fonte do navegador, e o mês em Fraunces 16 px 500 com 170 px mínimos.
 *
 * Como usar: quem monta passa o mês já escrito (`Setembro 2026`) e os dois
 * manipuladores, que mudam o mês aberto da página inteira. O nome acessível das
 * setas é "Voltar um mês" e "Avançar um mês", para não se confundirem com as do
 * Fechamento e com os atalhos de Lançamentos.
 */

interface SetasDoMesProps {
  /** O mês aberto, como `Setembro 2026`. */
  rotulo: string;
  onAnterior: () => void;
  onProximo: () => void;
}

/** O botão ‹ ou ›, na fonte que o navegador dá a todo botão sem `font-family`. */
const CLASSE_DA_SETA =
  '[font-family:revert] cursor-pointer rounded-[6px] border border-emb-borda bg-superficie px-[11px] py-1 text-[16px] leading-none text-foreground transition-all duration-100 hover:bg-emb-hover-bege';

/**
 * As setas do mês.
 *
 * @param rotulo - O mês aberto, já escrito.
 * @param onAnterior - Chamado pela seta ‹.
 * @param onProximo - Chamado pela seta ›.
 * @returns A fileira com as duas setas e o mês.
 */
export function SetasDoMes({ rotulo, onAnterior, onProximo }: SetasDoMesProps) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        aria-label="Voltar um mês"
        onClick={onAnterior}
        className={CLASSE_DA_SETA}
      >
        ‹
      </button>
      <span className="min-w-[170px] text-center font-serif text-[16px] font-medium text-foreground">
        {rotulo}
      </span>
      <button
        type="button"
        aria-label="Avançar um mês"
        onClick={onProximo}
        className={CLASSE_DA_SETA}
      >
        ›
      </button>
    </div>
  );
}
